<gl-base-modal (closeModal)="close(false)">
  <h2 class="title">{{ 'warning' | translate }}</h2>
  <p class="info">{{ descriptionKey | translate }}</p>
  <form>
    <gl-checkbox
      class="doNotShowAgain"
      [ngModel]="doNotShowAgain"
      (ngModelChange)="doNotShowAgain = $event"
      [ngModelOptions]="{ standalone: true }"
      [name]="'doNotShowAgain'"
      data-ctx="pallet-overflow-do-not-show-again"
    >
      {{ 'pallet_do_not_show_again_in_project' | translate }}
    </gl-checkbox>
  </form>
  <div class="buttons center">
    <button normal-button (click)="close(true)" data-ctx="button-pallet-overflow-yes">
      {{ 'yes' | translate }}
    </button>
    <button outline-button (click)="close(false)" data-ctx="button-pallet-overflow-cancel">
      {{ 'cancel' | translate }}
    </button>
  </div>
</gl-base-modal>
